var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.msg || 'No props passed yet'))]),_vm._v(" "+_vm._s(_vm.colIdx+'-'+_vm.value.key)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }